/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val, i = Math.floor(Math.abs(val)), v = val.toString().replace(/^[^.]*\.?/, '').length, e = parseInt(val.toString().replace(/^[^e]*(e([-+]?\d+))?/, '$2')) || 0;

if (n === 1)
    return 1;
if (e === 0 && (!(i === 0) && (i % 1000000 === 0 && v === 0)) || !(e >= 0 && e <= 5))
    return 4;
return 5;
}

export default ["es",[["a.â¯m.","p.â¯m."],u,["a.Â m.","p.Â m."]],u,[["D","L","M","X","J","V","S"],["dom","lun","mar","miÃ©","jue","vie","sÃ¡b"],["domingo","lunes","martes","miÃ©rcoles","jueves","viernes","sÃ¡bado"],["DO","LU","MA","MI","JU","VI","SA"]],u,[["E","F","M","A","M","J","J","A","S","O","N","D"],["ene","feb","mar","abr","may","jun","jul","ago","sept","oct","nov","dic"],["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"]],u,[["a. C.","d. C."],u,["antes de Cristo","despuÃ©s de Cristo"]],1,[6,0],["d/M/yy","d MMM y","d 'de' MMMM 'de' y","EEEE, d 'de' MMMM 'de' y"],["H:mm","H:mm:ss","H:mm:ss z","H:mm:ss (zzzz)"],["{1}, {0}",u,u,u],[",",".",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0Â %","#,##0.00Â Â¤","#E0"],"EUR","â¬","euro",{"AUD":[u,"$"],"BRL":[u,"R$"],"BYN":[u,"Ñ."],"CAD":[u,"$"],"CNY":[u,"Â¥"],"EGP":[u,"EGP"],"ESP":["â§"],"GBP":[u,"Â£"],"HKD":[u,"$"],"ILS":[u,"âª"],"INR":[u,"â¹"],"JPY":[u,"Â¥"],"KRW":[u,"â©"],"MXN":[u,"$"],"NZD":[u,"$"],"PHP":[u,"â±"],"RON":[u,"L"],"THB":["à¸¿"],"TWD":[u,"NT$"],"USD":["US$","$"],"XAF":[],"XCD":[u,"$"],"XOF":[]},"ltr", plural];
